(() => {
  'use strict';
  const page = document.querySelector('[data-bose-page]');
  const configNode = page?.querySelector('[data-bose-config]');
  const contextNode = page?.querySelector('[data-bose-localization-context]');
  if (!page || !configNode || !contextNode || window.BM_MARKET) return;
  const server = JSON.parse(contextNode.textContent);
  const product = JSON.parse(configNode.textContent);
  const markets = window.BM_MARKET_CONFIG?.markets;
  if (!markets) return;
  const url = new URL(location.href);
  const requested = (url.searchParams.get('country') || '').toUpperCase();
  const country = markets[server.country] ? server.country : 'DE';
  const market = markets[country];
  if (country === 'PL') window.BM_DICTIONARIES.pl = JSON.parse(document.querySelector('[data-audio-poland-dictionary="bose"]').textContent);
  const dictionary = window.BM_DICTIONARIES?.[market.language] || {};
  const normalize = text => String(text).replace(/\s+/g, ' ').trim();
  const t = (source, values = {}) => {
    let result = dictionary[normalize(source)] || source;
    Object.entries(values).forEach(([key, value]) => { result = result.replaceAll('{' + key + '}', String(value)); });
    return result;
  };
  const originals = new WeakMap();
  const excluded = element => element?.closest?.('script,style,[data-bose-policy-native],[data-bose-no-translate]');
  const translateText = node => {
    if (excluded(node.parentElement)) return;
    const current = node.nodeValue, key = normalize(current);
    if (!key) return;
    let source = originals.get(node);
    if (!source || normalize(t(source)) !== key) source = current;
    originals.set(node, source);
    const translated = t(normalize(source));
    if (translated !== normalize(source) && key !== normalize(translated)) node.nodeValue = source.replace(/\S[\s\S]*\S|\S/, translated);
  };
  const translateElement = element => {
    if (excluded(element)) return;
    for (const name of ['aria-label', 'alt', 'title', 'placeholder', 'aria-roledescription']) {
      const value = element.getAttribute(name);
      if (value && dictionary[normalize(value)] && t(value) !== value) element.setAttribute(name, t(value));
    }
  };
  const translateTree = root => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) { translateText(root); return; }
    if (![Node.ELEMENT_NODE, Node.DOCUMENT_FRAGMENT_NODE].includes(root.nodeType) || excluded(root)) return;
    if (root.nodeType === Node.ELEMENT_NODE) translateElement(root);
    root.querySelectorAll('[aria-label],[alt],[title],[placeholder],[aria-roledescription]').forEach(translateElement);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) translateText(walker.currentNode);
  };
  const state = window.BM_MARKET = { country, market, variants: product.variants, verified: false, pending: true, switching: false, checkoutPending: false, t, translateTree, server };
  window.BM_I18N = { t, translateTree };
  document.documentElement.lang = market.language;
  page.dataset.boseCountry = country; page.dataset.boseLanguage = market.language; page.dataset.boseCurrency = market.currency;
  translateTree(page); translateTree(document.querySelector('.bose-skip'));
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') translateText(record.target);
      else if (record.type === 'attributes') translateElement(record.target);
      else record.addedNodes.forEach(translateTree);
    }
  });
  observer.observe(page, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'alt', 'title', 'placeholder'] });
  const dialog = page.querySelector('[data-bose-market-dialog]');
  const desktopCountryControls = window.matchMedia('(min-width:1068px) and (hover:hover) and (pointer:fine)');
  const form = page.querySelector('#bose-localization-form');
  const message = page.querySelector('[data-bose-market-message]');
  const status = page.querySelector('[data-bose-market-status]');
  const options = page.querySelector('[data-bose-market-options]');
  const languages = { 'pt-PT': 'Português', de: 'Deutsch', ro: 'Română', hu: 'Magyar', cs: 'Čeština', pl: 'Polski' };
  let opener, previousOverflow = null, switchTimer;
  Object.entries(markets).forEach(([code, item]) => {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'bose-market-option'; button.dataset.boseChangeCountry = code;
    button.setAttribute('aria-pressed', String(code === country)); button.setAttribute('data-bose-no-translate', '');
    const name = document.createElement('span'); name.textContent = item.countryName;
    const detail = document.createElement('small'); detail.textContent = languages[item.language] + ' · ' + item.currency;
    button.append(name, detail); options.append(button);
  });
  page.querySelectorAll('[data-bose-market-code]').forEach(element => { element.textContent = country + ' · ' + market.currency; });
  page.querySelectorAll('[data-bose-market-name]').forEach(element => { element.textContent = market.countryName + ' · ' + languages[market.language] + ' · ' + market.currency; });
  page.querySelectorAll('[data-bose-market-open]').forEach(trigger => trigger.addEventListener('click', () => {
    if (state.checkoutPending || !desktopCountryControls.matches) return;
    opener = trigger; previousOverflow = document.documentElement.style.overflow;
    dialog.showModal(); document.documentElement.style.overflow = 'hidden'; trigger.setAttribute('aria-expanded', 'true');
  }));
  const restoreDialog = () => {
    if (previousOverflow === null) return;
    document.documentElement.style.overflow = previousOverflow; previousOverflow = null;
    page.querySelectorAll('[data-bose-market-open]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    if (desktopCountryControls.matches && opener?.getClientRects().length) opener.focus({ preventScroll: true });
  };
  const closeDialog = () => { dialog.close(); restoreDialog(); };
  const closeNonDesktopDialog = () => { if (!desktopCountryControls.matches && dialog.open) closeDialog(); };
  desktopCountryControls.addEventListener('change', closeNonDesktopDialog);
  closeNonDesktopDialog();
  page.querySelector('[data-bose-market-close]').addEventListener('click', closeDialog);
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();
  });
  dialog.addEventListener('close', restoreDialog);
  const notify = () => window.dispatchEvent(new CustomEvent('bose:market-state', { detail: state }));
  const switchCountry = code => {
    const target = markets[code];
    if (!target || state.switching || state.checkoutPending) return;
    if (code === server.country && server.language === target.language) { closeDialog(); return; }
    state.switching = true; notify();
    const destination = new URL(location.href);
    destination.pathname = target.root + '/products/' + server.handle;
    destination.searchParams.set('country', code); destination.searchParams.set('bose_market_attempt', code);
    form.elements.country_code.value = code; form.elements.language_code.value = target.language;
    form.querySelectorAll('input[name="return_to"]').forEach(input => { input.value = destination.pathname + destination.search + destination.hash; });
    message.textContent = t('A mudar de país…'); message.hidden = false;
    options.querySelectorAll('button').forEach(button => { button.disabled = true; });
    switchTimer = setTimeout(() => {
      state.switching = false; state.pending = false; notify();
      options.querySelectorAll('button').forEach(button => { button.disabled = false; });
      message.textContent = t('Não foi possível mudar de país. Tente novamente.'); status.textContent = message.textContent;
    }, 15000);
    form.requestSubmit();
  };
  options.addEventListener('click', event => { const button = event.target.closest('[data-bose-change-country]'); if (button) switchCountry(button.dataset.boseChangeCountry); });
  window.addEventListener('pagehide', () => clearTimeout(switchTimer), { once: true });
  const attempted = url.searchParams.get('bose_market_attempt');
  const desired = markets[requested] ? requested : country;
  page.querySelector('[data-bose-market-retry]')?.addEventListener('click', () => {
    if (desired !== server.country || server.language !== markets[desired].language) switchCountry(desired);
    else if (requested && !markets[requested]) {
      const recovered = new URL(location.href); recovered.searchParams.set('country', country); recovered.searchParams.delete('bose_market_attempt'); location.assign(recovered.href);
    } else verifyPrices();
  });
  if ((desired !== server.country || server.language !== markets[desired].language) && attempted !== desired) { switchCountry(desired); return; }
  if (desired !== server.country || server.language !== markets[desired].language || requested && !markets[requested]) {
    state.pending = false; message.textContent = t('Não foi possível mudar de país. Tente novamente.'); message.hidden = false; status.textContent = message.textContent; notify(); return;
  }
  if (attempted) { url.searchParams.delete('bose_market_attempt'); history.replaceState({}, '', url.pathname + url.search + url.hash); }
  let verification;
  const verifyPrices = async () => {
    if (verification) return verification;
    verification = (async () => {
      state.pending = true; state.verified = false; status.textContent = t('A verificar os preços…'); notify();
      try {
        if (market.language !== 'pt-PT' && !window.BM_DICTIONARIES?.[market.language]) throw new Error('Language unavailable');
        if (state.variants.length !== 7 || country !== 'PL' && (!market.price || !market.compareAtPrice)) throw new Error('Offer unavailable');
        const response = await fetch('/api/2026-10/graphql.json', {
          signal: AbortSignal.timeout(15000), method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: 'query BoseMarketPrices($ids: [ID!]!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) { nodes(ids: $ids) { ... on ProductVariant { id availableForSale price { amount currencyCode } compareAtPrice { amount currencyCode } product { id handle } } } localization { country { isoCode currency { isoCode } } language { isoCode } } }', variables: { ids: state.variants.map(variant => 'gid://shopify/ProductVariant/' + variant.id), country, language: market.apiLanguage } })
        });
        const result = await response.json(), nodes = result.data?.nodes, localized = result.data?.localization;
        if (!response.ok || result.errors?.length || nodes?.length !== 7 || localized?.country?.isoCode !== country || localized.country.currency.isoCode !== market.currency || localized.language.isoCode !== market.apiLanguage) throw new Error('Market unavailable');
        const verified = state.variants.map(variant => {
          const node = nodes.find(item => item?.id === 'gid://shopify/ProductVariant/' + variant.id);
          if (!node || node.product.id !== 'gid://shopify/Product/' + server.productId || node.price.currencyCode !== market.currency || !(Number(node.price.amount) > 0) || (country === 'PL' ? node.compareAtPrice && node.compareAtPrice.currencyCode !== market.currency : node.compareAtPrice?.currencyCode !== market.currency || Number(node.price.amount) !== Number(market.price) || Number(node.compareAtPrice.amount) !== Number(market.compareAtPrice))) throw new Error('Price mismatch');
          return { variant, node };
        });
        verified.forEach(({ variant, node }) => {
          variant.price = Math.round(Number(node.price.amount) * 100); variant.compareAtPrice = Math.round(Number(node.compareAtPrice?.amount || 0) * 100); variant.available = node.availableForSale;
        });
        state.verified = true; status.textContent = '';
      } catch { status.textContent = t('Os preços para este país não puderam ser confirmados. Tente novamente.'); }
      finally { state.pending = false; verification = null; notify(); }
    })();
    return verification;
  };
  state.verifyPrices = verifyPrices;
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    clearTimeout(switchTimer); state.switching = false; state.checkoutPending = false;
    options.querySelectorAll('button').forEach(button => { button.disabled = false; }); message.hidden = true; closeDialog(); verifyPrices();
  });
  page.dataset.boseLocalized = 'true';
  verifyPrices();
})();
